import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { AircraftPerformanceAudit } from '../../+models/aircraft-profile-audit.model';

@Component({
  selector: 'sd-portal-performance-audit-list',
  templateUrl: './performance-audit-list.component.html',
  styleUrls: ['./performance-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PerformanceAuditListComponent implements OnInit {
  @Input() aircraftPerformanceId: number;
  @Input() loading: boolean;
  @Input() aircraftPerformanceAudits: AircraftPerformanceAudit[];

  @Output() loadAircraftPerformance = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadAircraftPerformance.emit(this.aircraftPerformanceId);
  }

  onNextPage() {
    this.nextPage.emit(this.aircraftPerformanceId);
  }
}
